import { render, staticRenderFns } from "./FamCode.vue?vue&type=template&id=a166f410&scoped=true&"
import script from "./FamCode.vue?vue&type=script&lang=js&"
export * from "./FamCode.vue?vue&type=script&lang=js&"
import style0 from "./FamCode.vue?vue&type=style&index=0&id=a166f410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a166f410",
  null
  
)

component.options.__file = "FamCode.vue"
export default component.exports